(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[67780],{

/***/ 50182:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/debtreliefoasis",
      function () {
        return __webpack_require__(37522);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 37522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ DebtReliefOasisHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_debtreliefoasis_mainBanner_mainBanner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99318);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var _components_layouts_debtReliefOasisWrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7058);
/* harmony import */ var _components_shared_offersList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33124);
/* harmony import */ var _components_debtreliefoasis_debtFreePath__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1552);
/* harmony import */ var _components_debtreliefoasis_financialResiliencePath__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18948);
/* harmony import */ var _components_debtreliefoasis_qualitiesCompany__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47446);
/* harmony import */ var _components_debtreliefoasis_benefits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77877);










var __N_SSP = true;
function DebtReliefOasisHome() {
    const { domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts_debtReliefOasisWrapper__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_debtreliefoasis_mainBanner_mainBanner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                style: {
                    padding: "0 15px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_offersList__WEBPACK_IMPORTED_MODULE_5__["default"], {
                    offers: domain?.defaultOffers
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_debtreliefoasis_debtFreePath__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_debtreliefoasis_financialResiliencePath__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_debtreliefoasis_qualitiesCompany__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_debtreliefoasis_benefits__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [92592,10621,12672,7058,68810,49774,92888,40179], function() { return __webpack_exec__(50182); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);